import { Button } from '@utilitywarehouse/hearth-react';
import { media, useMediaQuery } from '@utilitywarehouse/hearth-react';
import { TrashMediumIcon } from '@utilitywarehouse/hearth-react-icons';

interface RemoveButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const RemoveButton = ({ onClick }: RemoveButtonProps) => {
  const isMobile = useMediaQuery(media.below('tablet'));

  return (
    <Button
      className="remove-button"
      variant={isMobile ? 'ghost' : 'outline'}
      size="md"
      colorScheme="destructive"
      onClick={onClick}
      data-testid="navbar-remove-button"
    >
      <TrashMediumIcon />
      Remove
    </Button>
  );
};

export { RemoveButton };
